export default __webpack_public_path__ + "static/milton-jones-998e2b0759f148f45a1b124bd1e1baaf.png";